export const BOOTCAMP_MODULES_REQUEST = "BOOTCAMP_MODULES_REQUEST";
export const BOOTCAMP_MODULES_SUCCESS = "BOOTCAMP_MODULES_SUCCESS";
export const  BOOTCAMP_MODULES_FAILURE = " BOOTCAMP_MODULES_FAILURE";